import { render, staticRenderFns } from "./IrMailingConfirmationsList.vue?vue&type=template&id=7b62ed03&"
import script from "./IrMailingConfirmationsList.vue?vue&type=script&lang=js&"
export * from "./IrMailingConfirmationsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports